import request from './axios'
// 每周推送
export function weekPushList(id) {
  return request({
    url: `/lx/createLog/getPushMsgFlag`,
    method: 'post'
  })
}
export function getweekPushList(id) {
  return request({
    url: `/lx/createLog/getPushMsg`,
    method: 'post'
  })
}
